/**
 * Centralized query/polling interval constants and role-checking utilities.
 *
 * QUERY_REFETCH_FAST   – 10 s  (operator session polling)
 * QUERY_STALE_NORMAL   – 20 s  (production summary stale time)
 * QUERY_REFETCH_NORMAL  – 30 s  (stats / station polling)
 * QUERY_REFETCH_SLOW    – 60 s  (low-priority polling, e.g. pending approvals)
 * MS_PER_HOUR          – 3 600 000 ms (elapsed-time math)
 */

// Query / polling intervals (milliseconds)
export const QUERY_REFETCH_FAST = 10_000;   // 10 seconds
export const QUERY_STALE_NORMAL = 20_000;   // 20 seconds
export const QUERY_REFETCH_NORMAL = 30_000; // 30 seconds
export const QUERY_REFETCH_SLOW = 60_000;   // 60 seconds
export const MS_PER_HOUR = 3_600_000;       // 1 hour

// Tick interval for re-rendering elapsed time labels (60 seconds)
export const TICK_INTERVAL = 60_000;

// ── Role constants ──────────────────────────────────────────────────────────

export const MANAGER_ROLES = ['M', 'manager'] as const;
export const ADMIN_ROLES = ['A', 'admin'] as const;
export const ELEVATED_ROLES = [...MANAGER_ROLES, ...ADMIN_ROLES] as const;

/** Returns true when the given role string represents a manager or admin. */
export const isElevatedRole = (role?: string): boolean =>
  ELEVATED_ROLES.includes(role as any);

/** Returns true when the given role string represents a MANAGER specifically (not admin/supervisor). */
export const isManagerRole = (role?: string): boolean =>
  MANAGER_ROLES.includes(role as any);
